import { showConfirm } from '../../components/BcConfirm'
import { FileApi } from '../../test-api/index.ts'
import Toast from '@/frontapp/mixins/actions/Toast'
import useBcFileStore from '@/frontapp/store/bcFile'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import { $t } from 'nette-base-module/js/vuei18next'
import $mitt from '../../../frontapp/emitter'

const fileApi = new FileApi({}, '/api/v2')

const doDeleteFiles = async function (fileIds, forceKey) {
     try {
        // delete
        await fileApi.fileMultipleDelete({ ids: fileIds, forceKey })
        
         // remove deleted files from list
        const bcFileStore = useBcFileStore()
        fileIds.forEach((id) => {
            bcFileStore.deleteFile(id)
        })
        
        Toast(
          'success',
          fileIds.length > 1 ? $t('%cnt% files were deleted', { cnt: fileIds.length }) : $t('File was deleted')
        )
        
        useBcSelectedStore().resetSelected()

        // triggers brandcloud global event bc-delete-file
        $mitt.emit('bc-delete-file', { fileIds: fileIds })

    } catch (error) {
        if (error.response.status !== 400) {
            throw error
        }

        const forceConfirm = await showConfirm({
            header: error.response.data.files.length === 1
                ? $t('File "%fileName%" is used', { fileName: error.response.data.files[0].name })
                : $t('%cnt% files are used', { cnt: error.response.data.files.length }),
            text: error.response.data.files.length === 1
                ? $t('File is used in these documents and after deleting you won\'t be able to work with it.')
                : $t('Files are used in these documents and after deleting you won\'t be able to work with them.'),
            body: 'BcConfirmBodyDeleteFile',
            files: error.response.data.files
        })

        if (!forceConfirm) {
            return
        }
        
        // force delete files
        return await doDeleteFiles(fileIds, error.response.data.forceKey) 
        
        /*
        Toast(
          'error',
          fileIds.length > 1 ? $t('Files can\'t be deleted') : $t('File can\'t be deleted')
        )
        */
    }
}

export default async function (fileIds) {
    const confirm = await showConfirm({
        header: $t(fileIds.length === 1 ? 'Do you want delete selected file?' : 'Do you want delete selected files?'),
    })

    if (!confirm) {
        return
    }

    return await doDeleteFiles(fileIds, null)
}
